export default __webpack_public_path__ + "static/media/771.44adf021.png";